import { User } from '../model/user';
import { ApiCrud } from './api-crud';
import http from './http';

const usersApi = new ApiCrud(http.AXIOS, User, 'users');

usersApi.add({
  mapAccounts: 'PUT /users/:userId/mapAccounts',
  mapAdvertisers: 'PUT /users/:userId/mapAdvertisers',
  removeAccount: 'DELETE /users/:userId/removeAccount',
  removeAdvertiser: 'DELETE /users/:userId/removeAdvertiser',
  removeUser: 'DELETE /users/:userId',
  // Send invite email to new user
  sendInvite: 'POST /users/:userId/invite?appName=:appName',
  inviteUrl: 'POST /users/:userId/invite/url',
  passwordResetUrl: 'POST /users/:userId/password_reset/url',
  allUsersForUserId:'GET /users/user/:userId/users',
});

export const userRolesApi = new ApiCrud(http.AXIOS, null, 'users');

userRolesApi.add({
  // get user-roles
  globalRoles: 'GET /users/:userId/globalRoles',
  createGlobalRoles: 'POST /users/:userId/globalRoles/:roleId',
  deleteGlobalRoles: 'DELETE /users/:userId/globalRoles/:roleId',
});

export default usersApi;
